module.exports = __webpack_public_path__ + "1793882494189/fonts/fa-solid-900.132e975.ttf";